// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"b690c9d8","744":"5a1bc5f2","787":"d4aba7ab","792":"3eee1d26","835":"0a8a5f30"}[chunkId] + ".chunk.js";
};